//export const BASE_URL = "http://localhost:5000";
export const BASE_URL = "https://foodmaniabackend.onrender.com";
